var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import api from 'app/core/api/api.js';
import { updateDataFromCollection } from './utils';
import { setAllTakes } from './takes';
import { setAllRelTakesFlags } from './takesFlags';
import { setAssetsFromTasks } from './assets';
import { setAllActivities } from './reduxActivities';
import { setAllTakeValidationMedias } from './reduxTakeValidationMedias';
import { setAllTakeRefMedias } from './reduxTakeRefMedias';
import { setAllMedias } from './reduxMedias';
import { setStateKey } from './stateKey';
import { verifyStartEndEarlyLatestDates } from 'app/store/hooks/tasks.js';
const initialState = {
    tasksByTable: {},
    relatedTasks: {
        data: [],
        loading: false,
        httpProgress: 0,
    },
};
export const fetchAllTasks = createAsyncThunk('reduxTasks/fetchAll', (_a, _b) => __awaiter(void 0, [_a, _b], void 0, function* ({ tableId, queries }, { fulfillWithValue, rejectWithValue, dispatch }) {
    if (!queries.ordering)
        delete queries.ordering;
    try {
        const res = yield api.tasks.fetchAll(Object.assign(Object.assign({}, queries), { statMode: 'datasOnly' }), {}, (progress) => {
            dispatch(setHttpProgress({ tableId, progress }));
        });
        const takes = res.results.flatMap((task) => task.takesInst);
        const rel_takeFlagsInst = takes.flatMap((take) => take.rel_takeFlagsInst);
        const assetInst = res.results.flatMap((task) => task.assetInst);
        const rel_takeRefMediasInst = takes.flatMap((take) => take.rel_takeRefMediasInst);
        const rel_takeValidationMediasInst = takes.flatMap((take) => take.rel_takeValidationMediasInst);
        const validationMediasInst = takes.flatMap((take) => take.validationMediasInst);
        const refMediasInst = takes.flatMap((take) => take.refMediasInst);
        dispatch(setAllTakes(takes));
        dispatch(setAllRelTakesFlags(rel_takeFlagsInst));
        dispatch(setAssetsFromTasks(assetInst));
        dispatch(setAllMedias([...validationMediasInst, ...refMediasInst]));
        dispatch(setAllTakeValidationMedias(rel_takeValidationMediasInst));
        dispatch(setAllTakeRefMedias(rel_takeRefMediasInst));
        dispatch(setStateKey('tasks'));
        return fulfillWithValue({ res, tableId });
    }
    catch (err) {
        return rejectWithValue(err);
    }
}));
export const fetchTasksByAsset = createAsyncThunk('reduxTasks/fetchByAsset', (_a, _b) => __awaiter(void 0, [_a, _b], void 0, function* ({ tableId, assetId, params }, { fulfillWithValue, rejectWithValue, dispatch }) {
    try {
        const res = yield api.assets.tasks({ id: assetId }, params.queries, params.headers, (progress) => {
            dispatch(setHttpProgress({ tableId, progress }));
        }, params.requestController);
        const takes = res.results.flatMap((task) => task.takesInst);
        const rel_takeFlagsInst = takes.flatMap((take) => take.rel_takeFlagsInst);
        const assetInst = res.results.flatMap((task) => task.assetInst);
        const rel_takeRefMediasInst = takes.flatMap((take) => take.rel_takeRefMediasInst);
        const rel_takeValidationMediasInst = takes.flatMap((take) => take.rel_takeValidationMediasInst);
        const validationMediasInst = takes.flatMap((take) => take.validationMediasInst);
        const refMediasInst = takes.flatMap((take) => take.refMediasInst);
        dispatch(setAllTakes(takes));
        dispatch(setAllRelTakesFlags(rel_takeFlagsInst));
        dispatch(setAssetsFromTasks(assetInst));
        dispatch(setAllMedias([...validationMediasInst, ...refMediasInst]));
        dispatch(setAllTakeValidationMedias(rel_takeValidationMediasInst));
        dispatch(setAllTakeRefMedias(rel_takeRefMediasInst));
        dispatch(setStateKey('tasks'));
        return fulfillWithValue({ res, tableId });
    }
    catch (err) {
        return rejectWithValue(err);
    }
}));
export const fetchAllTasksStats = createAsyncThunk('reduxTasksStats/fetchAll', (_a, _b) => __awaiter(void 0, [_a, _b], void 0, function* ({ tableId, filtersQueries }, { fulfillWithValue, rejectWithValue }) {
    try {
        const res = yield api.tasks.fetchAll(Object.assign({ statMode: 'statsOnly' }, filtersQueries));
        return fulfillWithValue({ tableId, res });
    }
    catch (err) {
        return rejectWithValue(err);
    }
}));
export const fetchUserTasks = createAsyncThunk('reduxTasks/fetchUserTasks', (_a, _b) => __awaiter(void 0, [_a, _b], void 0, function* ({ tableId, userId, queries }, { fulfillWithValue, rejectWithValue, dispatch }) {
    try {
        const res = yield api.tasks.fetchAll(Object.assign({ assignedUser: userId }, queries), {}, (progress) => {
            dispatch(setHttpProgress({ tableId, progress }));
        });
        const takes = res.results.flatMap((task) => task.takesInst);
        const rel_takeFlagsInst = takes.flatMap((take) => take.rel_takeFlagsInst);
        const assetInst = res.results.flatMap((task) => task.assetInst);
        dispatch(setAllTakes(takes));
        dispatch(setAllRelTakesFlags(rel_takeFlagsInst));
        dispatch(setAssetsFromTasks(assetInst));
        return fulfillWithValue({ res, tableId });
    }
    catch (err) {
        return rejectWithValue(err);
    }
}));
export const fetchMyTasks = createAsyncThunk('reduxTasks/fetchMyTasks', (...args_1) => __awaiter(void 0, [...args_1], void 0, function* ({ tableId, params } = {}, { fulfillWithValue, rejectWithValue, dispatch }) {
    try {
        const res = yield api.users.myTasks(null, Object.assign(Object.assign({}, params.queries), { statMode: 'datasOnly' }), {}, (progress) => {
            dispatch(setHttpProgress({ tableId, progress }));
        });
        const takes = res.results.flatMap((task) => task.takesInst);
        const rel_takeFlagsInst = takes.flatMap((take) => take.rel_takeFlagsInst);
        const assetInst = res.results.flatMap((task) => task.assetInst);
        const activities = res.results.flatMap((task) => task.activitiesInst);
        dispatch(setAllTakes(takes));
        dispatch(setAllRelTakesFlags(rel_takeFlagsInst));
        dispatch(setAssetsFromTasks(assetInst));
        dispatch(setAllActivities(activities));
        return fulfillWithValue({ res, tableId });
    }
    catch (err) {
        return rejectWithValue(err);
    }
}));
export const fetchMyPastTasks = createAsyncThunk('reduxTasks/fetchMyPastTasks', (_a, _b) => __awaiter(void 0, [_a, _b], void 0, function* ({ tableId, params }, { fulfillWithValue, rejectWithValue, dispatch }) {
    try {
        const res = yield api.users.myPastTasks(null, Object.assign(Object.assign({}, params.queries), { statMode: 'datasOnly' }), {}, (progress) => {
            dispatch(setHttpProgress({ tableId, progress }));
        });
        const takes = res.results.flatMap((task) => task.takesInst);
        const takesFlags = takes.flatMap((take) => take.rel_takeFlagsInst);
        const assetInst = res.results.flatMap((task) => task.assetInst);
        const activities = res.results.flatMap((task) => task.activitiesInst);
        dispatch(setAllTakes(takes));
        dispatch(setAllRelTakesFlags(takesFlags));
        dispatch(setAssetsFromTasks(assetInst));
        dispatch(setAllActivities(activities));
        return fulfillWithValue({ res, tableId });
    }
    catch (err) {
        return rejectWithValue(err);
    }
}));
export const updateTask = createAsyncThunk('reduxTasks/update', (_a, _b) => __awaiter(void 0, [_a, _b], void 0, function* ({ updatedTask, tableId }, { fulfillWithValue, rejectWithValue }) {
    try {
        yield verifyStartEndEarlyLatestDates(updatedTask);
        const res = yield api.tasks.collection.update(updatedTask);
        return fulfillWithValue({ res, tableId });
    }
    catch (err) {
        return rejectWithValue(err);
    }
}));
// actions for middleware
export const updateTaskAction = updateTask.fulfilled;
const { actions, reducer } = createSlice({
    name: 'reduxTasks',
    initialState,
    reducers: {
        setRelatedTasks: (state, { payload }) => {
            state.relatedTasks.data = payload;
        },
        updateTasksStatus: (state, { payload }) => {
            let newData;
            if (Array.isArray(payload)) {
                newData = updateDataFromCollection(state.relatedTasks.data, payload);
            }
            else {
                newData = [...state.relatedTasks.data].map((task) => {
                    if (task.id === payload.id) {
                        return Object.assign(Object.assign({}, task), payload);
                    }
                    return task;
                });
            }
            state.relatedTasks.data = newData;
        },
        resetRelatedTasks: (state) => {
            state.relatedTasks = {
                data: [],
                loading: false,
                httpProgress: 0,
            };
        },
        resetTableTasks: (state, { payload: tableId }) => {
            delete state.tasksByTable[tableId];
        },
        updateTaskFromWS: (state, { payload }) => {
            const updatedPayload = Object.assign(Object.assign({}, payload), { id: payload.uuid });
            delete updatedPayload.uuid;
            const newData = state.relatedTasks.data.map((task) => {
                if (task.id === updatedPayload.id) {
                    return Object.assign(Object.assign({}, task), updatedPayload);
                }
                return task;
            });
            state.relatedTasks.data = newData;
        },
        setHttpProgress: (state, { payload }) => {
            const { tableId, progress } = payload;
            state.tasksByTable[tableId].httpProgress = progress;
        },
    },
    extraReducers: (builder) => {
        // FETCH ALL TASKS
        builder.addCase(fetchAllTasks.pending, (state, { meta }) => {
            state.tasksByTable[meta.arg.tableId] = Object.assign(Object.assign({}, state.tasksByTable[meta.arg.tableId]), { loading: true });
        });
        builder.addCase(fetchAllTasks.fulfilled, (state, { payload }) => {
            const { res, tableId } = payload;
            state.tasksByTable[tableId] = Object.assign(Object.assign({}, state.tasksByTable[tableId]), { data: res.results, count: res.count, loading: false, httpProgress: 0 });
        });
        builder.addCase(fetchAllTasks.rejected, (state, { meta }) => {
            state.tasksByTable[meta.arg.tableId] = Object.assign(Object.assign({}, state.tasksByTable[meta.arg.tableId]), { loading: false });
        });
        // FETCH TASKS BY ASSET
        builder.addCase(fetchTasksByAsset.pending, (state, { meta }) => {
            state.tasksByTable[meta.arg.tableId] = Object.assign(Object.assign({}, state.tasksByTable[meta.arg.tableId]), { loading: true });
        });
        builder.addCase(fetchTasksByAsset.fulfilled, (state, { payload }) => {
            const { res, tableId } = payload;
            state.tasksByTable[tableId] = Object.assign(Object.assign({}, state.tasksByTable[tableId]), { data: res.results, count: res.count, loading: false, httpProgress: 0 });
        });
        builder.addCase(fetchTasksByAsset.rejected, (state, { meta }) => {
            state.tasksByTable[meta.arg.tableId] = Object.assign(Object.assign({}, state.tasksByTable[meta.arg.tableId]), { loading: false });
        });
        // FETCH MY TASKS
        builder.addCase(fetchMyTasks.pending, (state, { meta }) => {
            state.tasksByTable[meta.arg.tableId] = Object.assign(Object.assign({}, state.tasksByTable[meta.arg.tableId]), { loading: true });
        });
        builder.addCase(fetchMyTasks.fulfilled, (state, { payload }) => {
            const { res, tableId } = payload;
            const newTasks = res.results;
            state.tasksByTable[tableId] = Object.assign(Object.assign({}, state.tasksByTable[tableId]), { data: newTasks, count: res.count, loading: false, httpProgress: 0 });
        });
        builder.addCase(fetchMyTasks.rejected, (state, { meta }) => {
            state.tasksByTable[meta.arg.tableId] = Object.assign(Object.assign({}, state.tasksByTable[meta.arg.tableId]), { loading: false });
        });
        // FETCH MY PAST TASKS
        builder.addCase(fetchMyPastTasks.pending, (state, { meta }) => {
            state.tasksByTable[meta.arg.tableId] = Object.assign(Object.assign({}, state.tasksByTable[meta.arg.tableId]), { loading: true });
        });
        builder.addCase(fetchMyPastTasks.fulfilled, (state, { payload }) => {
            const { res, tableId } = payload;
            const newTasks = res.results;
            state.tasksByTable[tableId] = Object.assign(Object.assign({}, state.tasksByTable[tableId]), { data: newTasks, count: res.count, loading: false, httpProgress: 0 });
        });
        builder.addCase(fetchMyPastTasks.rejected, (state, { meta }) => {
            state.tasksByTable[meta.arg.tableId] = Object.assign(Object.assign({}, state.tasksByTable[meta.arg.tableId]), { loading: false });
        });
        // FETCH ALL TASKS STATS
        builder.addCase(fetchAllTasksStats.pending, (state, { meta }) => {
            state.tasksByTable[meta.arg.tableId] = Object.assign(Object.assign({}, state.tasksByTable[meta.arg.tableId]), { statsIsLoading: true });
        });
        builder.addCase(fetchAllTasksStats.fulfilled, (state, { payload }) => {
            const { res, tableId } = payload;
            state.tasksByTable[tableId] = Object.assign(Object.assign({}, state.tasksByTable[tableId]), { stats: res.stats, statsIsLoading: false });
        });
        builder.addCase(fetchAllTasksStats.rejected, (state, { meta }) => {
            state.tasksByTable[meta.arg.tableId] = Object.assign(Object.assign({}, state.tasksByTable[meta.arg.tableId]), { statsIsLoading: false });
        });
        // FETCH USER TASKS
        builder.addCase(fetchUserTasks.pending, (state, { meta }) => {
            state.tasksByTable[meta.arg.tableId] = Object.assign(Object.assign({}, state.tasksByTable[meta.arg.tableId]), { loading: true });
        });
        builder.addCase(fetchUserTasks.fulfilled, (state, { payload }) => {
            const { res, tableId } = payload;
            const newTasks = res.results;
            state.tasksByTable[tableId] = Object.assign(Object.assign({}, state.tasksByTable[tableId]), { data: newTasks, count: res.count, loading: false, httpProgress: 0 });
        });
        builder.addCase(fetchUserTasks.rejected, (state, { meta }) => {
            state.tasksByTable[meta.arg.tableId] = Object.assign(Object.assign({}, state.tasksByTable[meta.arg.tableId]), { loading: false });
        });
        // UPDATE TASK
        builder.addCase(updateTask.pending, () => { });
        builder.addCase(updateTaskAction, (state, { payload }) => {
            const { res, tableId } = payload;
            console.log('payload', payload);
            if (tableId) {
                const newAssetDetailsTableTasks = updateDataFromCollection(state.tasksByTable[tableId].data, res);
                state.tasksByTable[tableId].data = newAssetDetailsTableTasks;
                // if user is on AssetDetailsTableTask table from PlannerTaskTable table, we need to update the PlannerTaskTable too
                if (['AssetDetailsTableTask'].includes(tableId) && state.tasksByTable['PlannerTaskTable']) {
                    const newPlannerTableTasks = updateDataFromCollection(state.tasksByTable['PlannerTaskTable'].data, res);
                    state.tasksByTable['PlannerTaskTable'].data = newPlannerTableTasks;
                    // alternative: update all the tables in which the updatedTask exists
                    // const newTasksByTable = {}
                    // forEach(state.tasksByTable, (table, tableName) => {
                    //   const tableIds = table.data.map((task) => task.id)
                    //   if (tableIds.includes(res[0].id)) {
                    //     console.log(res)
                    //     const updatedTableData = [...table.data].map((task) => {
                    //       if (task.id === res[0].id) {
                    //         return res[0]
                    //       }
                    //       return task
                    //     })
                    //     newTasksByTable[tableName] = { ...table, data: updatedTableData }
                    //   }
                    // })
                    // state.tasksByTable = newTasksByTable
                }
            }
            else {
                const newAllTasksData = updateDataFromCollection(state.relatedTasks.data, res);
                state.relatedTasks.data = newAllTasksData;
            }
        });
        builder.addCase(updateTask.rejected, () => { });
    },
});
export const { 
// setAllTasks,
resetRelatedTasks, setRelatedTasks, resetTableTasks, updateTaskFromWS, setHttpProgress, updateTasksStatus, } = actions;
export default reducer;
